import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ConfirmationInput } from '../../../../components/confirmation/confirmation.model';

@Component({
  selector: 'vm-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss'],
})
export class ContactUsComponent {
  @Input() confirmationInput: ConfirmationInput;
  @Input() routerLinkText = 'Back';
  @Input() routerLinkHref = '../';
  @Input() workflowConstants = null;
  @Input() enableBackLink? = true;
  @Output() next = new EventEmitter();
  @Output() back = new EventEmitter();
  @Output() openSecondaryModal = new EventEmitter();

  onNext(id) {
    this.next.emit(id);
  }

  onBack(e) {
    this.back.emit(e);
  }

  onOpenSecondaryModal() {
    this.openSecondaryModal.emit();
  }
}
